import React from "react";
import "./metadatCard.css";
import { Link } from "react-router-dom";
import axios from "axios";
import { mainurl } from "../../actions/mainurl";
import { toast } from "react-toastify";
const MetaDataCard = ({ data, setDeleteSuccess }) => {

  const baseUrl = mainurl;

  const handleDelete = async (id) => {
    try {
      await axios.delete(`${baseUrl}/meta-data/delete-metadata/${id}`, {
        withCredentials: true,
      });
      toast.success("successfully deleted");
      setDeleteSuccess(id);
    } catch (error) {
    }
  };

  return (
    <div className="metadatacard">
      <img className="og_image" src={data.og_image} alt="" />
      <div className="page_name">
        {" "}
        page: <span>{data.page_name}</span>
      </div>
      <div className="meta_dec">{`${data.meta_dec.substring(0, 50)}...`}</div>
      <div className="button">
        <Link className="delete_button" to={`/edit-metadata/${data._id}`}>
          {" "}
          Edit{" "}
        </Link>
        <button onClick={() => handleDelete(data._id)} className="edit_button">Delete</button>
      </div>
    </div>
  );
};

export default MetaDataCard;
